import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CKEditorModule } from 'ckeditor4-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { MainService } from './provider/main.service';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';


//components
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LoginComponent } from './pages/login/login.component';
import { FooterComponent } from './pages/footer/footer.component';
import { HeaderComponent } from './pages/header/header.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SidebarComponent } from './pages/sidebar/sidebar.component';
import { OtpComponent } from './pages/otp/otp.component';
import { DashboardComponent } from './pages/dashboard/dashboard/dashboard.component';
import { SubadminMgtComponent } from './pages/dashboard/sub-admin/sub-admin-mgt/subadmin-mgt.component';
import { AddSubadminComponent } from './pages/dashboard/sub-admin/add-sub-admin/add-subadmin.component';
import { EditSubadminComponent } from './pages/dashboard/sub-admin/edit-sub-admin/edit-subadmin.component';
import { ViewSubadminComponent } from './pages/dashboard/sub-admin/view-sub-admin/view-subadmin.component';
import { AddPatientComponent } from './pages/dashboard/patient-management/add-patient/add-patient.component';
import { EditPatientComponent } from './pages/dashboard/patient-management/edit-patient/edit-patient.component';
import { MyProfileComponent } from './pages/dashboard/my-profile/my-profile.component';
import { ChangePasswordComponent } from './pages/dashboard/change-password/change-password.component';
import { PatientMgtComponent } from './pages/dashboard/patient-management/patient-mgt/patient-mgt.component';
import { ViewPatientComponent } from './pages/dashboard/patient-management/view-patient/view-patient.component';
import { AddTherapistComponent } from './pages/dashboard/therapist/add-therapist/add-therapist.component';
import { EditTherapistComponent } from './pages/dashboard/therapist/edit-therapist/edit-therapist.component';
import { TherapistMgtComponent } from './pages/dashboard/therapist/therapist-mgt/therapist-mgt.component';
import { StaffAvailabilityComponent } from './pages/dashboard/therapist/staff-availability/staff-availability.component';
import { ProgramMgtComponent } from './pages/dashboard/program/program-mgt/program-mgt.component';
import { AddProgramComponent } from './pages/dashboard/program/add-program/add-program.component';
import { EditProgramComponent } from './pages/dashboard/program/edit-program/edit-program.component';
import { TransactionMgtComponent } from './pages/dashboard/transaction-mgt/transaction-mgt.component';
import { AssessmentFormComponent } from './pages/dashboard/assessments/assessment-form/assessment-form.component';
import { StaticContentMgtComponent } from './pages/dashboard/static-content/static-content-mgt/static-content-mgt.component';
import { EditStaticContentComponent } from './pages/dashboard/static-content/edit-static-content/edit-static-content.component';
import { FaqMgtComponent } from './pages/dashboard/static-content/faq-mgt/faq-mgt/faq-mgt.component';
import { AfaqComponent } from './pages/dashboard/static-content/faq-mgt/add-faq/add-faq.component';
import { EditFaqComponent } from './pages/dashboard/static-content/faq-mgt/edit-faq/edit-faq.component';
import { ViewFaqComponent } from './pages/dashboard/static-content/faq-mgt/view-faq/view-faq.component';
import { NotificationComponent } from './pages/dashboard/notifications/notification.component';
import { LibraryMgtComponent } from './pages/dashboard/library/library-mgt/library-mgt.component';
import { AddLibraryComponent } from './pages/dashboard/library/add-library/add-library.component';
import { ViewLibraryComponent } from './pages/dashboard/library/view-library/view-library.component';
import { ReviewMgtComponent } from './pages/dashboard/review/review-mgt/review-mgt.component';
import { ViewReviewComponent } from './pages/dashboard/review/view-review/view-review.component';
import { ChatComponent } from './pages/dashboard/chat/chat.component';
import { JournalMgtComponent } from './pages/dashboard/journal/journal-mgt/journal-mgt.component';
import { ViewJournalComponent } from './pages/dashboard/journal/view-journal/view-journal.component';
import { EditJournalComponent } from './pages/dashboard/journal/edit-journal/edit-journal.component';
import { EditAssessmentComponent } from './pages/dashboard/assessments/edit-assessment/edit-assessment.component';
import { EditQuestionnaireComponent } from './pages/dashboard/assessments/edit-questionnaire/edit-questionnaire.component';
import { QueryMgtComponent } from './pages/dashboard/query-management/query-mgt/query-mgt.component';
import { ViewQueryComponent } from './pages/dashboard/query-management/view-query/view-query.component';
import { ProgramTypeMgtComponent } from './pages/dashboard/program-type-mgt/program-type-mgt.component';
import { AddProgramTypeComponent } from './pages/dashboard/program-type-mgt/add-program-type/add-program-type.component';
import { EditProgramTypeComponent } from './pages/dashboard/program-type-mgt/edit-program-type/edit-program-type.component';
import { ViewTherapistComponent } from './pages/dashboard/therapist/view-therapist/view-therapist.component';
import { PipeModule } from './pipes/pipe.module';

@NgModule({
  declarations: [
    AppComponent,
    ForgotPasswordComponent,
    LoginComponent,
    FooterComponent,
    HeaderComponent,
    ResetPasswordComponent,
    SidebarComponent,
    OtpComponent,
    DashboardComponent,
    SubadminMgtComponent,
    AddSubadminComponent,
    EditSubadminComponent,
    ViewSubadminComponent,
    AddPatientComponent,
    EditPatientComponent,
    MyProfileComponent,
    ChangePasswordComponent,
    PatientMgtComponent,
    ViewPatientComponent,
    AddTherapistComponent,
    EditTherapistComponent,
    TherapistMgtComponent,
    StaffAvailabilityComponent,
    ProgramMgtComponent,
    AddProgramComponent,
    EditProgramComponent,
    TransactionMgtComponent,
    AssessmentFormComponent,
    StaticContentMgtComponent,
    EditStaticContentComponent,
    FaqMgtComponent,
    AfaqComponent,
    EditFaqComponent,
    ViewFaqComponent,
    NotificationComponent,
    LibraryMgtComponent,
    AddLibraryComponent,
    ViewLibraryComponent,
    ReviewMgtComponent,
    ViewReviewComponent,
    ChatComponent,
    JournalMgtComponent,
    ViewJournalComponent,
    EditJournalComponent,
    EditAssessmentComponent,
    EditQuestionnaireComponent,
    QueryMgtComponent,
    ViewQueryComponent,
    ProgramTypeMgtComponent,
    AddProgramTypeComponent,
    EditProgramTypeComponent,
    ViewTherapistComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    NgOtpInputModule,
    NgxPaginationModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    ToastrModule.forRoot({
      maxOpened: 1,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      timeOut: 2000
    }),
    PipeModule,
    AppRoutingModule,
    CKEditorModule    
  ],
  providers: [
    MainService, 
    MatDatepickerModule,
    MatNativeDateModule
  ], 
  schemas: [CUSTOM_ELEMENTS_SCHEMA], 
  bootstrap: [AppComponent]
})
export class AppModule { }
